import { graphql } from "react-relay";
import { Environment, RecordSourceSelectorProxy } from "relay-runtime";

import {
  commitMutationPromiseNormalized,
  createMutation,
  MutationInput,
} from "coral-framework/lib/relay";

import { UpdateSiteBadgeRulesMutation as MutationTypes } from "coral-admin/__generated__/UpdateSiteBadgeRulesMutation.graphql";

let clientMutationId = 0;

const UpdateSiteBadgeRulesMutation = createMutation(
  "updateSiteBadgeRules",
  (environment: Environment, input: MutationInput<MutationTypes>) =>
    commitMutationPromiseNormalized<MutationTypes>(environment, {
      mutation: graphql`
        mutation UpdateSiteBadgeRulesMutation($input: UpdateSiteBadgesInput!) {
          updateSiteBadges(input: $input) {
            modifiedCount
            clientMutationId
          }
        }
      `,
      variables: {
        input: {
          ...input,
          clientMutationId: (clientMutationId++).toString(),
        },
      },
      updater: (store: RecordSourceSelectorProxy) => {
        const root = store.getRoot();
        root.setValue(null, "allSiteBadgeRules");
      },
    })
);

export default UpdateSiteBadgeRulesMutation;
